import * as React from 'react';
import { useSelector } from 'react-redux';
import { getCanBeAddedInsurancesByGroups } from '../../../store/order/selectors';
import InsuranceUpsale from '../../../../CheckoutAdditionalService/components/InsuranceUpsale/InsuranceUpsale';
import InsuranceUpsaleAggregator from '../../../../CheckoutAdditionalService/components/InsuranceUpsale/InsuranceUpsaleAggregator';
import InsuranceV2 from '../../../../CheckoutAdditionalService/components/InsuranceUpsale/InsuranceUpsaleV2';
const OrderInsuranceBlockSlotUpsale = ({ aggregatorMode = false, cardV2Style, segmentId }) => {
    const insurancesByGroups = useSelector(getCanBeAddedInsurancesByGroups);
    let Insurance = InsuranceUpsale;
    if (aggregatorMode) {
        Insurance = InsuranceUpsaleAggregator;
    }
    if (cardV2Style) {
        Insurance = InsuranceV2;
    }
    return (React.createElement(React.Fragment, null, insurancesByGroups.map((insurances, index) => (React.createElement(Insurance, { key: index, groupName: insurances.groupName, insurancePrograms: insurances.insurancePrograms, oldVersion: true, segmentId: segmentId })))));
};
export default OrderInsuranceBlockSlotUpsale;
